// React imports
import { useMemo, useEffect } from 'react';

// FontAwesome imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus, faRefresh } from '@fortawesome/free-solid-svg-icons';

// MUI imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import Autocomplete from '@mui/material/Autocomplete';  
import IconButton from '@mui/material/IconButton';

// Generic imports
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import CurrencyList from 'currency-list';
import { formatDisplayDate } from '../utils/date.js';


function ExchangeRates(props) {
    const { organization, setOrganization } = props;

    useEffect(() => {
        if (organization.exchangeRates && _.some(organization.exchangeRates, r => !r.id)) {
            const rates = _.cloneDeep(organization.exchangeRates);
            rates.map(r => r.id = r.id || uuidv4());
            setOrganization({ ...organization, exchangeRates: rates });
        }
    }, [organization]);

    const rates = _.get(organization, 'exchangeRates', []);

    const options = useMemo(() => {
        return Object.keys(CurrencyList.getAll('en_US')).map(currency => currency);
    }, []);


    return (
        <Box sx={{ p: 3 }}>
            {rates.map(r => {
                return (
                    <Box key={r.id} sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1, maxWidth: '900px' }}>
                        <Box>
                        1
                        </Box>
                        <Autocomplete
                            sx={{ flex: 1 }}
                            options={options}
                            getOptionLabel={option => `${CurrencyList.getAll('en_US')[option].name} (${option}, ${CurrencyList.getAll('en_US')[option].symbol})`}
                            renderInput={(params) => <TextField {...params} />}
                            value={r.from}
                            onChange={(e, value) => {
                                const o = JSON.parse(JSON.stringify(organization));
                                _.set(o, 'exchangeRates', rates.map(r2 => r2.id === r.id ? { ...r2, from: value } : r2));
                                setOrganization(o);
                            }}
                        />
                        <Box>
                            is equal to 
                        </Box>
                        <TextField
                            value={r.rate}
                            sx={{ width: '100px' }}
                            onChange={(e) => {
                                const o = JSON.parse(JSON.stringify(organization));
                                _.set(o, 'exchangeRates', rates.map(r2 => r2.id === r.id ? { ...r2, rate: e.target.value } : r2));
                                setOrganization(o);
                            }}
                        />
                        <Autocomplete
                            sx={{ flex: 1 }}
                            options={options}
                            getOptionLabel={option => `${CurrencyList.getAll('en_US')[option].name} (${option}, ${CurrencyList.getAll('en_US')[option].symbol})`}
                            renderInput={(params) => <TextField {...params} />}
                            value={r.to}
                            onChange={(e, value) => {
                                const o = JSON.parse(JSON.stringify(organization));
                                _.set(o, 'exchangeRates', rates.map(r2 => r2.id === r.id ? { ...r2, to: value } : r2));
                                setOrganization(o);
                            }}
                        />
                        <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '11px', flexDirection: 'column', justifyContent: 'center' }}>
                            <Box>
                                Last updated: {formatDisplayDate(r.updatedAt)}
                            </Box>
                            <Button size='small' variant='contained' color='primary' sx={{ textTransform: 'none' }} onClick={() => {
                                const o = JSON.parse(JSON.stringify(organization));
                                _.set(o, 'exchangeRates', rates.map(r2 => r2.id === r.id ? { ...r2, updatedAt: new Date().getTime() } : r2));
                                setOrganization(o);
                            }}>
                                <FontAwesomeIcon icon={faRefresh} />
                                <span style={{ paddingLeft: '6px', fontSize: '9px' }}>
                                    Mark as updated
                                </span>
                            </Button>
                        </Box>
                        <IconButton variant='contained' color='error' sx={{ ml: 2 }} onClick={() => {
                            const o = JSON.parse(JSON.stringify(organization));
                            _.set(o, 'exchangeRates', rates.filter(r2 => r2.id !== r.id));
                            setOrganization(o);
                        }}>
                            <FontAwesomeIcon icon={faTrash} />
                        </IconButton>
                    </Box>
                )

            })}
            <Button variant='contained' color='primary' sx={{ mb: 2 }} onClick={() => {
                const o = JSON.parse(JSON.stringify(organization));
                _.set(o, 'exchangeRates', [...rates, {
                    id: uuidv4(),
                    from: organization.defaults?.currency,
                    to: organization.defaults?.currency === 'USD' ? 'EUR' : 'USD',
                    rate: 1,
                    updatedAt: new Date().getTime()
                }]);
                setOrganization(o);
            }}>
                <FontAwesomeIcon icon={faPlus} />
                <span style={{ paddingLeft: '6px' }}>
                    Add Exchange Rate
                </span>
            </Button>

        </Box>
    )
}

export default ExchangeRates;